var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageLoadingMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 1870,
    viewBox: "0 0 393 1870",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_435)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 1870,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 2012,
    transform: "translate(0 -101)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 41,
    width: 329,
    height: 30,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 129,
    width: 329,
    height: 30,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 169,
    width: 329,
    height: 30,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 209,
    width: 329,
    height: 30,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 303,
    width: 329,
    height: 397,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 738,
    width: 329,
    height: 397,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1173,
    width: 329,
    height: 397,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 81,
    width: 329,
    height: 10,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 266,
    width: 123,
    height: 10,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 572,
    width: 186,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 1007,
    width: 186,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 1442,
    width: 186,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1674,
    width: 186,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1690,
    width: 186,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1706,
    width: 186,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1722,
    width: 186,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1738,
    width: 186,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 1842,
    width: 265,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 547,
    width: 186,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 982,
    width: 186,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 1417,
    width: 186,
    height: 10,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 516,
    width: 186,
    height: 25,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 951,
    width: 186,
    height: 25,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 1386,
    width: 186,
    height: 25,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1636,
    width: 186,
    height: 25,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 632,
    width: 186,
    height: 40,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 1067,
    width: 186,
    height: 40,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 1502,
    width: 186,
    height: 40,
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 1870,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLoadingMobile);
export default __webpack_public_path__ + "static/media/page_loading_mobile.a1d976073fd607b5955b58ae6d5d0e1b.svg";
export { ForwardRef as ReactComponent };